/**
 * ViewReport Modal component module.
 * @module shared/components/modals/content/ViewReport
 *
 */

import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import BaseModal from '../types/Base';
import {_openModal, _removeModal} from '../../../store';
import PropTypes from 'prop-types';
import axiosInstance from '../../../utils/axios';
import styled from 'styled-components';
import {LoadingSpinner} from '../../../../shared';
import debug from 'debug';
import PDF from '../../PDF';

const log = debug('circleblack:view-report-modal');

const _iframe = styled.iframe`
  width: 100%;
  height: 500px;
  background-color: white;
`;
/**
 * View Report modal component to view different types of documents.
 * @name ViewReport
 */
const ViewReport = props => {
  const {dispatchRemoveModal, content, openModal} = props;
  // const document = content.document;
  const document = content.document;
  const inputValue = {};
  const [uri, setUri] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstance.get(`reports/${document.id}/download?`, {params: {...inputValue}})
      .then(res => {
        setLoading(false);
        setUri(res.data.uri);
      })
      .catch(function error(err) {
        log('error', err);
        let res = err.response;
        if (!(res.status < 500 && res.data.error && res.data.error.msg)) {
          err.message = 'Unfortunately we encountered an error retrieving the document. If you have any questions, please contact CircleBlack Client Services at help@circleblack.com or 800-315-1241.';
        }
        openModal({
          type: 'Error',
          title: 'Failed to Retrieve Document',
          err: err,
        });
      });
  }, []);

  return <BaseModal onClose={() => dispatchRemoveModal(content)} title={document.targetContext} size={'lg'}>
    {(document.format === 'html' && uri) && !loading
    && <_iframe src={uri}
                type='text/html'
                loading={loading}
                frameBorder='0'>
    </_iframe>}
    {document.format === 'pdf' && uri && !loading
    && <PDF uri={uri}/>}
    {loading && <LoadingSpinner/>}
  </BaseModal>;
};

const mapDispatchToProps = dispatch => ({
  dispatchRemoveModal: modal => {
    dispatch(_removeModal(modal));
  },
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default connect(null, mapDispatchToProps)(ViewReport);

ViewReport.propTypes = {
  /**
   * content of the modal with modal component name
   */
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    /**
     * name of modal component
     */
    componentName: PropTypes.string.isRequired,
    /**
     * document object being displayed in the modal
     */
    document: PropTypes.object.isRequired,
  }),
  /**
   * The open modal function to dispatch _openModal from Redux
   */
  openModal: PropTypes.func.isRequired,
  /**
   * The remove modal function to dispatches _removeModal from Redux
   */
  dispatchRemoveModal: PropTypes.func.isRequired,
};

